import BaseRequestService from "./base-request-service";

class contact extends BaseRequestService {
    getContacts = () => this.getRequest('api/contacts/get');
    postContact = query => this.postRequest('api/contacts/send-mail', query)
}

export default new contact();